import { UserContext } from '@services/Session';
import { useContext, useState } from 'react';
import { Box, Button, Layer, Text } from 'grommet';
import { Close } from 'grommet-icons';

interface PrivacyModalProps {
  onUpdateUnlistedSetting: (unlisted: boolean) => void;
  onClose: () => void;
}
export const PrivacyModal: React.FC<PrivacyModalProps> = ({
  onUpdateUnlistedSetting,
  onClose,
}) => {
  const userStore = useContext(UserContext);
  const team = userStore.selectedTeam;

  const [loading, setLoading] = useState(false);

  return (
    <Layer onClickOutside={onClose} onEsc={onClose}>
      <Box
        direction="row"
        pad="medium"
        align="center"
        justify="between"
        gap="medium"
      >
        <Box width="24px" />
        <Text weight="bold">Change Privacy Settings</Text>
        <Close size="24px" onClick={onClose} />
      </Box>
      <Box pad={{ horizontal: 'medium' }} gap="medium">
        <Text>
          {`Future YouTube broadcasts for ${team?.nameMed} will start as public and are set unlisted when the broadcast finishes.`}
        </Text>
        <Text>
          The channel manager can change the privacy setting of any broadcast at
          any time on YouTube.
        </Text>
        <Box>
          <Text>Unlisted broadcasts:</Text>
          <Text>{` • Won't be searchable on YouTube`}</Text>
          <Text>
            {` • Only team members that have logged in to sidelineHD (families, coaches, team managers) can see these links`}
          </Text>
        </Box>
        <Box margin={{ bottom: 'large' }} gap="medium">
          <Button primary label="Keep broadcasts public" onClick={onClose} />
          <Button
            disabled={loading}
            secondary
            label="Auto-set to unlisted after broadcast finishes"
            onClick={() => {
              setLoading(true);
              onUpdateUnlistedSetting(true);
            }}
          />
        </Box>
      </Box>
    </Layer>
  );
};
